import { Alert, Container } from 'react-bootstrap';

interface ErrorComponentProps {
  message: string;
  title?: string;
  className?: string;
}

const ErrorComponent = ({
  message,
  title = 'An error occurred',
  className = '',
}: ErrorComponentProps) => {
  return (
    <Container fluid className={`py-5 ${className}`}>
      <Alert
        variant="danger"
        className="border-0 shadow-sm d-flex align-items-start"
      >
        <i
          className="bi bi-exclamation-triangle-fill me-3 flex-shrink-0 mt-1"
          style={{ fontSize: '24px' }}
        ></i>
        <div>
          {title && <h5 className="alert-heading mb-2 fw-semibold">{title}</h5>}
          <p className="mb-0">{message}</p>
        </div>
      </Alert>
    </Container>
  );
};

export default ErrorComponent;
